import {Component, effect, inject, model, ModelSignal} from '@angular/core';
import {
  CSV_IMPORT_ACTION,
  DEFAULT_TABLE_ACTIONS,
  ITableAction,
  SharedGridOptions,
  TableControlComponent,
  TableControlModule,
  ToolbarStore,
} from 'frontier/browserkit';
import {IFilter, INITIAL_STATE_TOKEN} from 'frontier/nucleus';
import {GridOptions} from 'ag-grid-community';
import AppControlGuids from '../../../api/ControlGuids';

@Component({
  selector: 'app-alternative-table-payer',
  templateUrl: '../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.html',
  styleUrls: [
    '../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.scss'
  ],
  standalone: true,
  imports: [TableControlModule],
  providers: [
    {provide: INITIAL_STATE_TOKEN, useValue: {filter: null}},
    {provide: TableControlComponent, useExisting: AlternativePayerTableComponent},
  ],
})
export class AlternativePayerTableComponent extends TableControlComponent {
  private _toolbarStore: ToolbarStore = inject(ToolbarStore);
  override GUID: string = AppControlGuids.TAlternativePayerView;
  override tableName: string = 'Alternative Kostenträger';
  override gridOptions: GridOptions = {
    ...SharedGridOptions,
  };
  override actions: ModelSignal<ITableAction[]> = model<ITableAction[]>([
    ...DEFAULT_TABLE_ACTIONS,
    CSV_IMPORT_ACTION,
  ]);

  constructor() {
    super();
    effect(() => {
      const toolbarFilterDto: IFilter = this._toolbarStore.toolbarFilterDto();
      if (toolbarFilterDto) {
        this.patchFilter({
          ...toolbarFilterDto
        });
      }
    }, {allowSignalWrites: true});
  }
}
